import * as Sentry from '@sentry/react';

if (
  window.appConfig.SENTRY_DSN != null &&
  window.appConfig.APP_ENV === 'production' &&
  window.appConfig.APP_RELEASE != null
) {
  Sentry.init({
    dsn: window.appConfig.SENTRY_DSN,
    integrations: [],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: window.appConfig.APP_ENV,
    release: window.appConfig.APP_RELEASE,
    ignoreErrors: [
      /access-by-country-policy__confirm ng-scope/,
      /cg-notify-message ng-scope access-by-country-policy cg-notify-message-center/,
      /document\.getElementsByClassName\('gotya\d'\)\[0\]\.value/,
      /document\.getElementsByTagName\('video'\)\[\d\]\./,
      /ChunkLoadError/i,
      /Non-Error promise rejection captured with keys: errors, success/,
    ],
    beforeSend(e) {
      if (
        e.request != null &&
        e.request.url != null &&
        e.request.url.search(/game\/.+/) !== -1
      ) {
        return null;
      }

      const isSkipError = !!e.exception?.values?.find((value) => {
        return value.stacktrace?.frames?.find((frame) => {
          return (
            frame.filename?.includes('cdn.onesignal.com') ||
            frame.filename?.includes('iframe.a8r.games')
          );
        });
      });

      if (isSkipError) return null;

      return e;
    },
  });

  import('@sentry/react').then((lazyLoadedSentry) => {
    Sentry.addIntegration(
      lazyLoadedSentry.replayIntegration({ blockAllMedia: false })
    );
  });
}
